import React, { useEffect, useState } from 'react';

import { getPostCheckoutSurveyOptions } from '../api';
import { Spinner } from '../assets/Spinner';
import { Table } from '../component/Table';

type PostCheckoutSurveyOption = {
  id: string;
  label: string;
  value: string;
  status_us: string;
  status_ca: string;
  marketing_source: string | null;
  marketing_bucket: string | null;
};

const headers = [
  'Customer-Facing Label',
  'Internal Value',
  'US Status',
  'CA Status',
  'Marketing Source',
  'Marketing Bucket',
];

export const PostCheckoutSurveyOptions = () => {
  const [options, setOptions] = useState<PostCheckoutSurveyOption[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchOptions = async () => {
    setIsLoading(true);
    try {
      const data = await getPostCheckoutSurveyOptions();
      setOptions(data);
    } catch (e) {
      console.error('Failed to fetch post-checkout survey options', e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  const mapOption = (option: PostCheckoutSurveyOption) => ({
    'Customer-Facing Label': option.label,
    'Internal Value': option.value,
    'US Status': <input type="checkbox" checked={option.status_us === 'ACTIVE'} readOnly />,
    'CA Status': <input type="checkbox" checked={option.status_ca === 'ACTIVE'} readOnly />,
    'Marketing Source': option.marketing_source ?? '--',
    'Marketing Bucket': option.marketing_bucket ?? '--',
  });

  if (isLoading) return <Spinner />;

  return (
    <div className="relative h-[calc(100vh-77px)] bg-slate50 p-8">
      <h1 className="mb-6">Manage Post-Purchase Survey</h1>
      <Table header={headers} data={options.map(mapOption)} />
    </div>
  );
};
